import { getClientsList } from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, hideErrorMessage } from "./ui";

//Загрузка списка клиентов
export const CLIENTS_LOADING_START = "Clients loading start";
export const CLIENTS_LOADING_SUCCESS = "Clients list loading success";
export const CLIENTS_LOADING_FAILED = "Failure during clients list load";

//Пагинация
export const CHANGE_CLIENTS_PAGE = "Change clients page";
export const CHANGE_CLIENTS_LIMIT = "Change clients limit";

//Поиск
export const CHANGE_CLIENTS_SEARCH = "Change clients search";
export const START_CLIENTS_SEARCH = "Switch clients search";
export const CLEAR_CLIENTS_SEARCH = "Clear clients search";

//Сортировка
export const CHANGE_CLIENTS_SORTING = "Change clients sorting options";

const startLoading = () => ({
  type: CLIENTS_LOADING_START 
});

const loadSuccess = clients => ({
  type: CLIENTS_LOADING_SUCCESS,
  payload: {
    clients: clients || []
  }
});

const loadFailure = () => ({
  type: CLIENTS_LOADING_FAILED,
});

//Загрузка списка клиентов
export const getClientsListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let clients;
    try {
      const accessToken = localStorage.getItem("accessToken");
      clients = await getClientsList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка клиентов!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(clients));
  };
};

//Пагинация на странице списка клиентов
export const changeClientsPage = activePage => ({
  type: CHANGE_CLIENTS_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка клиентов
export const changeClientsLimit = activeLimit => ({
  type: CHANGE_CLIENTS_LIMIT,
  payload: { activeLimit }
});

//Поиск
export const changeClientsSearch = value => ({ 
  type: CHANGE_CLIENTS_SEARCH,
  payload: { value }
});

export const startClientsSearch = value => ({
  type: START_CLIENTS_SEARCH,
  payload: { value }
});

export const clearClientsSearch = () => ({
  type: CLEAR_CLIENTS_SEARCH,
});

//Сортировка
export const changeClientsSorting = (sort, order) => ({ 
  type: CHANGE_CLIENTS_SORTING,
  payload: { sort, order }
});